import React from 'react';
import { motion } from 'framer-motion';

function MetricDonutChart({ segments, value, label, icon, iconAlt }) {
  return (
    <div className="metric-column">
      <div className="donut-chart">
        <svg viewBox="0 0 128 128">
          {/* グラデーション定義 */}
          <defs>
            <linearGradient id="greyToGreen" gradientTransform="rotate(90)">
              <stop offset="0%" stopColor="#D9D9D9" />
              <stop offset="100%" stopColor="#91D494" />
            </linearGradient>
          </defs>

          {/* セグメントのレンダリング */}
          {segments.map((segment, index) => (
            <motion.circle
              key={index}
              cx="64"
              cy="64"
              r="40"
              fill="transparent"
              stroke={segment.color}
              strokeWidth="30"
              strokeDasharray={segment.dasharray}
              strokeDashoffset={segment.dashoffset}
              transform="rotate(-90 64 64)"
              initial={{ strokeDashoffset: 251.33, opacity: 0 }}
              animate={{ strokeDashoffset: segment.dashoffset, opacity: 1 }}
              transition={{
                duration: 1,
                delay: index * 0.1,
                ease: "easeOut",
                // アニメーション完了後に offset を維持
                transitionEnd: { strokeDashoffset: segment.dashoffset }
              }}
            />
          ))}
        </svg>
        <div className="metric-value">
          <motion.span
            initial={{ opacity: 0, x: -10 }} // 最初は少し左にオフセット
            animate={{ opacity: 1, x: 0 }}   // アニメーションで中央に移動
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {value}
          </motion.span>
        </div>
      </div>
      <div className="metric-label">
        <img src={icon} width="15" height="15" alt={iconAlt} />
        <span>{label}</span>
      </div>
    </div>
  );
}

export default MetricDonutChart;
